export default "__VITE_ASSET__Td5b1mQi__"